import { render } from "./Privacy.vue?vue&type=template&id=37354a60&scoped=true&bindings={}"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=37354a60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37354a60"

export default script